import { log } from '../../common/log';
import { request } from '../../common/request';
import {
  miloCaseUploadAttachments as miloCaseUploadAttachmentsUrl,
  workfrontCaseAttachmentsUpload as workfrontCaseAttachmentsUploadUrl,
} from '../../common/urls';
import { removeImageLoader } from './support-loader';
import { ClientId } from '../../common/keys';
import { getSelectedOrg, isCommerce, isECC } from './support-org-util';
import { notice } from '../../common/notice';
import { getLabel, labels } from '../../common/labels';
import { relicApiFail, relicApiSuccess } from './relic';

const RELIC_CASE_CREATION_AVAILABILITY_TRACKING = {
  title: 'Case Creation Availability',
  duration: 10,
};

const FAIL_ERROR = 'There was an error retrieving attachments';

export const uploadWorkfrontCaseAttachments = async (caseId, files, userprofile) => {
  log('Uploading case Attachment DATA');
  await labels();
  const responseData = [];
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const workfrontCaseAttachmentsUploadStart = performance.now();
    const workfrontCaseAttachmentsUploadDuration = Number((performance.now() - workfrontCaseAttachmentsUploadStart) );
    try {
      const caseBody = new FormData();
      caseBody.append('file', file);
      const uploadAttachmentsOptions = {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          caseId,
          contactRengaId: userprofile.email,
        },
        body: caseBody,
      };
      const res = await request(`${workfrontCaseAttachmentsUploadUrl}`, {
        ...uploadAttachmentsOptions,
      });
      const data = await res.json();
      if (res.ok) {
        relicApiSuccess({
          endpoint: workfrontCaseAttachmentsUploadUrl,
          duration: workfrontCaseAttachmentsUploadDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        responseData.push(data.data.attachment);
      } else {
        relicApiFail({
          status:data.status,
          endpoint: workfrontCaseAttachmentsUploadUrl,
          duration: workfrontCaseAttachmentsUploadDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        removeImageLoader();
        notice(getLabel(FAIL_ERROR), true, void 0, 'negative', 0);
        log(`Failed to upload the image: ${data.error}`);
      }
    } catch (err) {
      relicApiFail({
        status:err.status,
        endpoint: workfrontCaseAttachmentsUploadUrl,
        duration: workfrontCaseAttachmentsUploadDuration,
        ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
      });
      removeImageLoader();
      notice(getLabel(FAIL_ERROR), true, void 0, 'negative', 0);
      log(`There was some error while uploading the attachment: ${err.message}`);
    }
  }

  return responseData;
};

export const uploadMiloCaseAttachments = async (caseId, files) => {
  log(`Uploading case Attachment DATA${caseId}`);
  const responseData = [];
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    try {
      let orgSourceValue = 'IMS';
      if (isCommerce()) {
        orgSourceValue = 'AMC';
      }
      if (isECC()) {
        orgSourceValue = 'ECC';
      }
      const caseBody = new FormData();
      caseBody.append('file', file);
      const uploadAttachmentsOptions = {
        method: 'POST',
        headers: {
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          id: caseId,
          regarding: 'incident',
          orgId: getSelectedOrg().id,
          orgSource: orgSourceValue
        },
        body: caseBody,
      };
      const res = await request(miloCaseUploadAttachmentsUrl, {
        ...uploadAttachmentsOptions,
      });
      const data = await res.json();
      if (res.ok) {
        responseData.push(data.attachment);
      } else {
        removeImageLoader();
        notice(exlStrings.supportAttachmentsFailError, true, void 0, 'negative', 0);
        log(`Failed to upload the image: ${data.error}`);
      }
    } catch (err) {
      removeImageLoader();
      notice(exlStrings.supportAttachmentsFailError, true, void 0, 'negative', 0);
      log(`There was some error while uploading the attachment: ${err.message}`);
    }
  }

  return responseData;
};
